import React, { useEffect, useState } from 'react';
import { MenuBar } from './MenuBar';
import { Dock } from './Dock';
import { Window } from './Window';
import { CommandPalette } from './CommandPalette';
import { ControlCenter } from './ControlCenter';
import { DesktopIcons } from './DesktopIcons';
import { AboutApp } from './apps/AboutApp';
import { ProjectsApp } from './apps/ProjectsApp';
import { TerminalApp } from './apps/TerminalApp';
import { MailApp } from './apps/MailApp';
import { SafariApp } from './apps/SafariApp';
import { ResumeApp } from './apps/ResumeApp';
export const Desktop: React.FC = () => {
  const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);
  const [isControlCenterOpen, setIsControlCenterOpen] = useState(false);
  const [brightness, setBrightness] = useState(100);
  const [volume, setVolume] = useState(70);
  const [darkMode, setDarkMode] = useState(true);
  const [wifi, setWifi] = useState(true);
  const [bluetooth, setBluetooth] = useState(true);
  const [airplane, setAirplane] = useState(false);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setIsCommandPaletteOpen(prev => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  const brightnessOverlay = 1 - brightness / 100;
  return <div className={`relative w-screen h-screen overflow-hidden bg-mac-wallpaper bg-cover bg-center flex flex-col ${darkMode ? '' : 'brightness-110'}`} data-id="element-284" data-mp="19adrjxqvuip5">
      {!darkMode && <div className="absolute inset-0 bg-white/30 pointer-events-none z-[1]" data-id="element-285" data-mp="ze0zf4azkcwi" />}

      <div className="absolute inset-0 bg-black pointer-events-none z-[2] transition-opacity duration-300" style={{
      opacity: brightnessOverlay * 0.7
    }} data-id="element-286" data-mp="14b9jxbjlwt0x" />

      <MenuBar onOpenCommandPalette={() => setIsCommandPaletteOpen(true)} onToggleControlCenter={() => setIsControlCenterOpen(p => !p)} wifi={wifi} data-id="element-287" data-mp="ue4tv0mn4deu" />

      <main className="flex-1 relative overflow-hidden" data-id="element-288" data-mp="2sa3j3s2bvc4r">
        <DesktopIcons data-id="element-289" data-mp="2s8iok2g0jt6w" />

        <Window id="finder" data-id="element-290" data-mp="2s80n8rehuos4">
          <AboutApp data-id="element-291" data-mp="2n9z280xicfe0" />
        </Window>
        <Window id="xcode" data-id="element-292" data-mp="2nba8c7efdz8a">
          <ProjectsApp data-id="element-293" data-mp="2n8eask6hpckd" />
        </Window>
        <Window id="terminal" data-id="element-294" data-mp="2icp4lxzysxf3">
          <TerminalApp data-id="element-295" data-mp="2idgzf6lqmr4b" />
        </Window>
        <Window id="mail" data-id="element-296" data-mp="3fz5ysudeiuwm">
          <MailApp data-id="element-297" data-mp="3fyd2knc2jnsq" />
        </Window>
        <Window id="safari-github" data-id="element-298" data-mp="3fxboe9zral6s">
          <SafariApp type="github" data-id="element-299" data-mp="3azteaga05zx7" />
        </Window>
        <Window id="safari-linkedin" data-id="element-300" data-mp="3b14fc8c2ctkm">
          <SafariApp type="linkedin" data-id="element-301" data-mp="360ymwpxyz31h" />
        </Window>
        <Window id="safari-portfolio" data-id="element-302" data-mp="35zf4asoucfwj">
          <SafariApp type="portfolio" data-id="element-303" data-mp="31zwv2u6dtt9j" />
        </Window>
        <Window id="resume" data-id="element-304" data-mp="31z3opubc55rx">
          <ResumeApp data-id="element-305" data-mp="1um3893zbp1kx" />
        </Window>
      </main>

      <Dock data-id="element-306" data-mp="1umutplz7hixh" />

      <CommandPalette isOpen={isCommandPaletteOpen} onClose={() => setIsCommandPaletteOpen(false)} data-id="element-307" data-mp="1unmlsmtlgyj0" />

      <ControlCenter isOpen={isControlCenterOpen} onClose={() => setIsControlCenterOpen(false)} brightness={brightness} setBrightness={setBrightness} volume={volume} setVolume={setVolume} darkMode={darkMode} setDarkMode={setDarkMode} wifi={wifi} setWifi={setWifi} bluetooth={bluetooth} setBluetooth={setBluetooth} airplane={airplane} setAirplane={setAirplane} data-id="element-308" data-mp="1qmudpwwgkzob" />
    </div>;
};